module.exports = __webpack_public_path__ + "static/media/facebook.2d50905b.svg";